<template>
    <div v-if="buyToast" class="toaskMask" @touchmove.prevent>
        <div class="buyModal">
            <div class="title-text" v-if="albumDetail.photoViewType == 'DOWNLOAD'">根据拍摄方要求，该照片需要进行付费后才可进行下载，一经购买概不退款。已购买的照片可以在“已购”中查看。</div>
            <div class="title-text" v-if="albumDetail.photoViewType == 'WATERMARK'">根据拍摄方要求，该照片需要进行付费后才可下载无水印大图，一经购买概不退款。已购买的照片可以在“已购”中查看。</div>
            <div class="buy-content">
                <div class="close" @click="close">关闭</div>
                <img v-if="buyPhotoInfo.photoUrlOutline" :src="buyPhotoInfo.photoUrlOutline" class="buy-photo" style="pointer-events: none" />
                <div class="price">￥{{ albumDetail.photoPrice }}</div>
                <div class="buy-btn" @click="confirmBuy('single')">
                    <div>立即购买</div>
                    <div v-if="albumDetail.discount" class="discountTips">满{{ albumDetail.discountPhotoCount }}张打{{ albumDetail.discountProportion / 10 }}折</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, reactive } from 'vue';
const emit = defineEmits(['close', 'afterBuyRefresh', 'buy']);

defineProps({
    buyToast: {
        type: Boolean,
        default: false
    },
    buyPhotoInfo: {
        type: Object,
        default: {}
    },
    albumDetail: {
        type: Object,
        default: {}
    }
});
const close = () => {
    emit('close');
}

const confirmBuy = (type: string) => {
    emit('buy');
}
</script>
<style scoped>
    .discountTips{
        position: absolute;
        top: -10px;
        right: -30px;
        background: #FF782D;
        color: #fff;
        font-size: 12px;
        height: 20px;
        border-radius: 10.5px 9.5px 10.5px 0px;
        display: flex;
        align-items: center;
        padding: 0 5px;
    }
</style>